import { invalidateChatUsersCache } from './invalidateChatUsersCache'
import { invalidateChatConversationsCache } from './invalidateChatConversationsCache'

export const ChatSliceReducers = {
  invalidateUsersCache: invalidateChatUsersCache,
  invalidateConversationsCache: invalidateChatConversationsCache,
}
